// import { useRoute } from "vue-router";
import { QueryStringDataBuilder } from "@/core/QueryString/QueryStringDataBuilder";
//import { BlobConfigDataBuilder } from "../../service/blobConfig/BlobConfigDataBuilder";
import ConfigManager from "@/config/ConfigManager";
import BzbsApiLegacy from "@/core/Http/BzbsApiLegacy"
import Utility from "@/helper/Utility";
//import BlobService from "@/core/Blob/service/BlobService";
import BzbsAuth from "@/core/Account/service/BzbsAuth";
import { ErrorType } from "@/helper/ErrorType.js";

export default function (states, localeStore) {
    // const route = useRoute()
    /**
     *
     * @returns {Promise}
     */
    const loadConfig =  function () {
        // load config from url query string
        return  new Promise((resolve) => { 
            let quantity = new QueryStringDataBuilder()
            states.query = quantity.create();
            states.query.loadCache()
            
            if (states.query.hasCache()) {
                localeStore.setters.setLocale(states.query.locale)
                initialConfig().then((res) => {
                    resolve(res)
                }).catch((err) => {
                    resolve(err)
                });
            } else {
                resolve()
            }
        });
        
    }

    const initialConfig = function () { 
        if (states.query.appId) {
            states.blobUrl = `${ConfigManager.getBlobUrl()}/config/${states.mainAppName}/${states.query.appId}`;
        } 
  
        return Promise.all([getBlobApiConfig()]).then((results) => {
            return results
        })
    }
 
    const getBlobApiConfig = function () {
        
        return new Promise((resolve, reject) => {
            let app_id = "";
            var version = states.query.version;
            if (version == 2) { 
                // หาชื่อไฟล์จาก app_id 
                app_id = states.query.appId;
                var blob_path = Utility.getUrlBlobJsonFromTheme(app_id, version);
                if (!blob_path) {
                    // พาไป error 
                    states.error_code = ErrorType.AppMapping
                    reject({
                        error_code: ErrorType.AppMapping
                    });
                    return;
                } 
                // get landing blob config
                BzbsApiLegacy.getBlobWeblandingConfigByBlobPath(blob_path).then((res_config) => {
                    states.blobWebLanding = res_config
                    resolve(states.blobWebLanding) 
                }).catch((err) => {
                    console.log(err)
                    states.blobWebLanding = null
                    reject(err)
                });
            }
            else {
                // theme mapping
                // version 1
                BzbsApiLegacy.getBlobAppThemeMapping().then((app_mapping) => {   
                    app_id = Utility.getAppIdFromTheme(app_mapping, states.query.theme);
                    //console.log(app_id, ErrorType.AppMapping);
                    var blob_path = Utility.getUrlBlobJsonFromTheme(app_id, version); 
                    // get landing blob config
                    BzbsApiLegacy.getBlobWeblandingConfigByBlobPath(blob_path).then((res_config) => {
                        states.blobWebLanding = res_config
                        resolve(states.blobWebLanding) 
                    }).catch((err) => {
                        console.log(err)
                        states.blobWebLanding = null
                        reject(err)
                    });
                }).catch((err) => {
                    console.log(err)
                    states.blobWebLanding = null
                    reject(err)
                });
            }
        })
    }

    const loadPayload = function (accKey) {
        return new Promise((resolve, reject) => {
            // console.log(states)
            BzbsAuth.apiReadAccessKey(accKey).subscribe({
                next: (res) => {
                    // console.log(res.data)
                    // update query model by payload then the flow go as usual
                    let queryString = new QueryStringDataBuilder()
                    states.query = queryString.setWithQuery(res.data, true).create()
                    states.query.accessKey = accKey // update access token
                    resolve(res.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }

    return {
        loadConfig,
        getBlobApiConfig, 
        loadPayload,
    }
}
